import {
    apiRequest,
    punishmentList,
    punishmentActive,
    punishmentInactive
} from "../../../../../services/adapters/master/punishmentService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", punishmentList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", punishmentInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", punishmentActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository